function getValuesFromPropmtResponse(promptValue) {
    try {
        let json = JSON.parse(promptValue);

        if (__DEBUG__)
            console.debug('getValuesFromPropmtResponse json', { json });

        return {
            artist: json.Artist,
            title: json.Title,
            lyrics: json.Lyrics,
            style: json.Style,
            keywords: json.Keywords
        }
    } catch(ex) {
        if (__DEBUG__)
            console.error(ex);
    }
    

    let matches = (promptValue || '').match(new RegExp(`"(.*?)":`, 'g'));
    let split = (promptValue || '').split(new RegExp(`"(.*?)":`, 'g'));

    let result = {};

    let startIdx = -1;
    ['artist', 'title', 'keywords', 'imageprompt', 'lyrics', 'style'].map(w => {
        if (startIdx === -1) {
            startIdx = split.findIndex(f => (f || '').toLowerCase() === w);
        }
    });

    let processValue = (v) => {
        v = (v || '')
            .replace(/\\+n/g, '\n')
            .replace(/\*/g, '')
            .replace(/\\/g, '')
            .replace(/"/g, '')
            .replace(/[{}]/g, '')
            .trim()
            .replace(/^,/, '').replace(/,$/, '');

        return v;
    }

    for (let i = startIdx; i < split.length; i += 2) {
        result[(split[i] || '').toLowerCase()] = processValue(split[i + 1]);
    }

    if (__DEBUG__)
        console.debug('getValueFromPropmtResponse', { matches, split, result, startIdx });

    return result;
}

export {
    getValuesFromPropmtResponse
}